import React, {Component} from 'react'
import PropTypes from "prop-types";

class FormElementContainerHeight extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let {title,Component,rest,isSub} = this.props
        return (
            <div className={'patientsFormBoxesHeight'}>
                <Component {...rest} />
            </div>

        )
    }
}

FormElementContainerHeight.propTypes = {
    title: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default FormElementContainerHeight;
